// /** @format */
import axios from 'axios';
import { SERVERURL } from '../app/Utilities/Constants';
import { toast } from 'react-hot-toast';
const instance = axios.create({
    baseURL: SERVERURL
});
instance.interceptors.response.use((response) => {
    return response;
}, (error) => {
    var _a, _b, _c;
    if (error.response && error.response.status === 401) {
        window.location.href = '#/login';
        return;
    }
    else if (error.response) {
        const errorMessage = (_b = (_a = error.response.data) === null || _a === void 0 ? void 0 : _a.message) === null || _b === void 0 ? void 0 : _b.description;
        // Handle duplicate entry error
        if (((_c = error.response.data) === null || _c === void 0 ? void 0 : _c.code) === 'ER_DUP_ENTRY') {
            toast.error('Duplicate Entry Detected.');
        }
        else if (errorMessage) {
            toast.error(`${errorMessage}`);
        }
        else {
            toast.error(error.response.data.message ||
                error.response.data.error ||
                'Something went wrong!');
        }
    }
    else if (error.request) {
        console.error('No response received:', error.request);
        toast.error('No response received: ' + JSON.stringify(error.request));
    }
    else {
        console.error('Request Error:', error.message);
        toast.error('Request Error: ' + error.message);
    }
    return Promise.reject(error);
});
export default {
    GetServerCall: (URL, methodType, token, params) => instance({
        method: methodType,
        url: URL,
        params: params,
        headers: {
            'content-type': 'application/json',
            Accept: 'application/json',
            token: token
        }
    }),
    PostServerCall: (URL, methodType, token, params) => instance({
        method: methodType,
        url: URL,
        data: params,
        headers: {
            'content-type': 'application/json',
            Accept: 'application/json',
            token: token
        }
    })
};
